export const getCompanySettings = (state) => {
  return state?.companySettings;
};
